import { Component, Input, OnInit } from "@angular/core";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { Siniestro } from "app/dto/siniestro.dto";

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DDTHH:mm:ss.000",
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "print-siniestro",
  templateUrl: "./print-siniestro.component.html",
  styleUrls: ["./print-siniestro.component.scss"],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }],
})
export class SiniestroPrintComponent implements OnInit {
  @Input() siniestro: Siniestro;

  constructor() {
  }

  ngOnInit() {}

  getEstados() {
    return this.siniestro
      ? this.siniestro?.venta?.estados
          .map(function (e) {
            return e.descripcion;
          })
          .join(", ")
      : "";
  }
}
